<template>
  <AdminAddEmployeesPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminAddEmployeesPage from "shared-ui/pages/AdminAddEmployeesPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_add_employees.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
